module.exports = __webpack_public_path__ + "img/comment-minus.f6bb564a.svg";